import { render, staticRenderFns } from "./WorkflowMinimap.vue?vue&type=template&id=2241abea&scoped=true&"
import script from "./WorkflowMinimap.vue?vue&type=script&lang=ts&setup=true&"
export * from "./WorkflowMinimap.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./WorkflowMinimap.vue?vue&type=style&index=0&id=2241abea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2241abea",
  null
  
)

export default component.exports